<template>
  <div id="index" ref="appRef">
    <div class="search_b">
      <el-button size="small" class="search_btn1" icon="el-icon-refresh" @click="allsearch">刷新</el-button>
      <el-date-picker v-model="timess" type="daterange" size="small" value-format="yyyy-MM-dd" range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期">
      </el-date-picker>
      <el-button size="small" class="search_btn" @click="begin" type="primary">搜索</el-button>
    </div>
    <div class="bg" :style="'height:' + bgheight + 'px'">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <div class="d-flex jc-center">
          <dv-decoration-10 class="dv-dec-10" />
          <div class="d-flex jc-center">
            <dv-decoration-8 class="dv-dec-8" :color="['#568aea', '#000000']" />
            <div class="title">
              <span class="title-text">大数据可视化平台</span>
              <dv-decoration-6 class="dv-dec-6" :reverse="true" :color="['#50e3c2', '#67a1e5']" />
            </div>
            <dv-decoration-8 class="dv-dec-8" :reverse="true" :color="['#568aea', '#000000']" />
          </div>
          <dv-decoration-10 class="dv-dec-10-s" />
        </div>

        <!-- 头 -->
        <div class="d-flex jc-between px-2">
          <div class="d-flex aside-width">
            <div class="react-left ml-4 react-l-s">
              <span class="react-before"></span>
              <span class="text" style="margin-right: 5px">数据分析</span>
              <el-button :type="act == 1 ? 'success' : 'primary'" size="mini" class="text" @click="getDataList(1)">用户量
              </el-button>
              <el-button :type="act == 2 ? 'success' : 'primary'" size="mini" class="text" @click="getDataList(2)">关注量
              </el-button>
              <el-button :type="act == 5 ? 'success' : 'primary'" size="mini" class="text" @click="getDataList(5)">日活量
              </el-button>
              <el-button :type="act == 3 ? 'success' : 'primary'" size="mini" class="text" @click="getDataList(3)">转化量
              </el-button>

              <el-button :type="act == 4 ? 'success' : 'primary'" size="mini" class="text" @click="getDataList(4)">其他
              </el-button>
            </div>
          </div>
          <div class="d-flex aside-width">
            <div class="react-right bg-color-blue mr-3">
              <span class="text fw-b">正汉平台</span>
            </div>
            <div class="react-right mr-4 react-l-s">
              <span class="react-after"></span>
              <span class="text">{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span>
            </div>
          </div>
        </div>
        <!-- 用户 -->
        <div class="body-box" v-if="boxshow == 1">
          <div class="bototm-box">
            <dv-border-box-12 v-loading="userloading" element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
              <bottomRight2 ref="bottomRight2_1" :text="'新增日用户'" />
            </dv-border-box-12>
            <dv-border-box-12 v-loading="userloading" element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
              <bottomRight2 ref="bottomRight2_2" :text="'新增周用户'" />
            </dv-border-box-12>
            <dv-border-box-12 v-loading="userloading" element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
              <bottomRight2 ref="bottomRight2_3" :text="'新增月用户'" />
            </dv-border-box-12>
            <dv-border-box-12 v-loading="userloading" element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
              <bottomRight ref="bottomRight" :text="'用户'" />
            </dv-border-box-12>
          </div>
          <div>
            <div>
              <!-- <dv-border-box-12 > -->
              <viplevel />
              <!-- </dv-border-box-12> -->
            </div>
          </div>
        </div>
        <!-- 关注 -->
        <div class="body-box" v-if="boxshow == 2">
          <div class="content-box2">
            <dv-border-box-12 element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading">
              <bottomRight4 ref="bottomRight213" :text="'新增日关注'" />
            </dv-border-box-12>
            <dv-border-box-12 element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading">
              <bottomRight4 ref="bottomRight214" :text="'新增周关注'" />
            </dv-border-box-12>
            <dv-border-box-12 element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading">
              <bottomRight4 ref="bottomRight215" :text="'新增月关注'" />
            </dv-border-box-12>
            <dv-border-box-12 element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading">
              <bottomRight4 ref="bottomRight216" :text="'总关注'" />
            </dv-border-box-12>

            <!-- <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight24" :text="'新增用户日关注'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight25" :text="'新增用户周关注'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight26" :text="'新增用户月关注'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight217" :text="'用户总关注'" />
            </dv-border-box-12>

            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight27" :text="'新增医生日关注'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight28" :text="'新增医生周关注'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight29" :text="'新增医生月关注'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight218" :text="'医生总关注'" />
            </dv-border-box-12>

            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight210" :text="'新增机构日关注'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight211" :text="'新增机构周关注'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight212" :text="'新增机构月关注'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight219" :text="'机构总关注'" />
            </dv-border-box-12> -->
          </div>
        </div>
        <!-- 日活量 -->
        <div class="body-box" v-if="boxshow == 5">
          <!-- 第一行数据 -->
          <div class="content-box2">
            <dv-border-box-12 element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading">
              <bottomRight4 ref="bottomRight513" :text="'日活'" />
            </dv-border-box-12>
            <dv-border-box-12 element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading">
              <bottomRight4 ref="bottomRight514" :text="'周活'" />
            </dv-border-box-12>
            <dv-border-box-12 element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading">
              <bottomRight4 ref="bottomRight515" :text="'月活'" />
            </dv-border-box-12>
            <dv-border-box-12 element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading">
              <bottomRight4 ref="bottomRight516" :text="'总活'" />
            </dv-border-box-12>

            <!-- <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight54" :text="'用户日活'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight55" :text="'用户周活'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight56" :text="'用户月活'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight517" :text="'用户总活'" />
            </dv-border-box-12>

            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight57" :text="'医生日活'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight58" :text="'医生周活'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight59" :text="'医生月活'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight518" :text="'医生总活'" />
            </dv-border-box-12>

            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight510" :text="'机构日活'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight511" :text="'机构周活'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight512" :text="'机构月活'" />
            </dv-border-box-12>
            <dv-border-box-12
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <bottomRight2 ref="bottomRight519" :text="'机构总活'" />
            </dv-border-box-12> -->
          </div>
        </div>
        <!-- 转化 -->
        <div class="body-box" v-if="boxshow == 3">
          <!-- 第一行数据 -->
          <el-row>
            <el-col :span="12">
              <dv-border-box-12 element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading">
                <bottomLeft4 ref="bottomLeft4" />
              </dv-border-box-12>
            </el-col>
            <el-col :span="12">
              <dv-border-box-12 element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading">
                <bottomRight3 ref="bottomRight3" />
              </dv-border-box-12>
            </el-col>
          </el-row>

        </div>
        <!-- 其他 -->
        <div class="body-box" v-if="boxshow == 4">
          <!-- 第一行数据 -->
          <!-- <div class="bototm-box">
            <dv-border-box-13>
              <bottomLeft ref="bottomLeft1" />
            </dv-border-box-13>
          </div> -->
          <!-- 第二行数据 -->
          <div class="content-box">
            <div>
              <dv-border-box-12>
                <centerLeft2 ref="centerLeft2" />
              </dv-border-box-12>
            </div>
            <div>
              <dv-border-box-12>
                <centerLeftage ref="centerLeftage" />
              </dv-border-box-12>
            </div>
            <div>
              <dv-border-box-12>
                <centerLeft1 ref="centerLeft1" />
              </dv-border-box-12>
            </div>
          </div>
          <!-- 第三行数据 -->
          <div class="san-box">
            <div>
              <dv-border-box-13>
                <threecenter :inquiry2="inquirys" :mall="malls" ref="threedata" />
              </dv-border-box-13>
            </div>
          </div>
          <!-- 第四行数据 -->
          <div class="content-box4">
            <div>
              <dv-border-box-12>
                <centerLeft3 ref="centerLeft3" />
              </dv-border-box-12>
            </div>
            <div>
              <dv-border-box-13>
                <bottomLeft ref="bottomLeft1" />
              </dv-border-box-13>
            </div>
            <div>
              <dv-border-box-13>
                <!-- <centerRight1 /> -->
                <centerLeft4 ref="centerLeft4" />
              </dv-border-box-13>
            </div>
          </div>
        </div>
        <div v-if="boxshow != 4">
          <div class="add_tits" ref="titles">
            <el-form :inline="true" class="form-inline">
              <el-form-item label="日期">
                <el-date-picker v-model="fm_dated" size="small" value-format="yyyy-MM-dd" type="daterange"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="searchday"></el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="last_search">昨天</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="three_search">3天</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="seven_search">7天</el-button>
              </el-form-item>
              <!-- <el-form-item>
                    <el-button size="small" type="primary" @click="fifth_search">15天</el-button>
                </el-form-item> -->
              <el-form-item>
                <el-button size="small" type="primary" @click="month_search">本月</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="lastmonth_search">上月</el-button>
              </el-form-item>
            </el-form>
            <el-form :inline="true" class="form-inlines">
              <el-form-item label="对比">
                <el-date-picker v-model="values" type="daterange" size="small" :clearable="false" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="search_day">日对比</el-button>
              </el-form-item>
              <el-form-item>
                <el-date-picker v-model="zdb_value1" size="small" type="week" format="yyyy 第 WW 周" ref="week1"
                  placeholder="开始周" value-format="yyyy-MM-dd" :clearable="false" id="week1" class="zwidth">
                </el-date-picker>
                <el-date-picker v-model="zdb_value2" size="small" type="week" format="yyyy 第 WW 周" ref="week2"
                  placeholder="结束周" value-format="yyyy-MM-dd" :clearable="false" id="week2" class="zwidth">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="search_week">周对比</el-button>
              </el-form-item>
              <el-form-item>
                <el-date-picker v-model="ydb_value1" size="small" type="month" placeholder="开始月" class="ywidth"
                  value-format="yyyy-MM" :clearable="false" id="month1"></el-date-picker>
                <el-date-picker v-model="ydb_value2" size="small" type="month" placeholder="结束月" class="ywidth"
                  value-format="yyyy-MM" :clearable="false" id="month2"></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" @click="search_month">月对比</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="tabssty">
            <el-table :data="tableData1" v-loading="loading1" element-loading-background="rgba(0, 0, 0, 0.8)" border
              :height="Heighttab" ref="table" class="tabhstyle">
              <el-table-column v-for="(item, ind) in header" :key="ind" :label="item.name" align="center">
                <el-table-column v-show="item.child.length > 0" v-for="iteme in item.child" :prop="iteme.key"
                  :key="iteme.key" :label="iteme.name" align="center">
                  <el-table-column v-show="iteme.child.length > 0" v-for="itemed in iteme.child" :prop="itemed.key"
                    :key="itemed.key" :label="itemed.name" align="center">
                  </el-table-column>
                  <template slot-scope="{ row }" v-if="iteme.child.length < 1">
                    {{ row[iteme.key] }}
                  </template>
                </el-table-column>
                <template slot-scope="{ row }" v-if="item.child.length < 1">
                  {{ row[item.key] }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="导出数据" :visible.sync="exportModal" width="30%" center>
      <el-form :model="exportForm" ref="ruleForm">
        <el-form-item label="时间范围" prop="time">
          <el-date-picker v-model="exportForm.time" type="date" size="small" value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportModal = false">取 消</el-button>
        <el-button type="primary" :loading="dcing" @click="exportExcel">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import drawMixin from "../../../utils/drawMixin";
  import {
    formatTime
  } from "../../../utils/index.js";
  import centerLeft1 from "./centerLeft1";
  import centerLeft2 from "./centerLeft2";
  import centerLeftage from "./centerLeftage.vue";
  import centerLeft3 from "./centerLeft3";
  import centerLeft4 from "./centerLeft4";
  import centerRight1 from "./centerRight1";
  import centerRight2 from "./centerRight2";
  import center from "./center";
  import threecenter from "./threecenter.vue";
  import viplevel from "./viplevel.vue";
  import bottomLeft from "./bottomLeft";
  import bottomLeft4 from "./bottomLeft4";
  import bottomLeft2 from "./bottomLeft2";
  import bottomRight from "./bottomRight";
  import bottomRight2 from "./bottomRight2";
  import bottomRight3 from "./bottomRight3";
  import bottomRight4 from "./bottomRight4";
  export default {
    // mixins: [drawMixin],
    data() {
      return {
        userloadings: false,
        timing: null,
        loading: true,
        fm_dated: [],
        dateDay: null,
        dateYear: null,
        dateWeek: null,
        weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
        exportModal: false,
        tableData: [],
        count: 0,
        currentPage: 1,
        pagesize: 10,
        exportModal: false,
        exportForm: {
          time: "",
        },
        dcing: false,
        loadings: false,
        timess: "",
        bgheight: 0,
        inquirys: {
          total_count: 0,
          total_price: 0,
        },
        userRegisters: {},
        docRegisters: {},
        phoneUsers: {},
        malls: {},
        ishow: 1,
        boxshow: 4,
        test: "",
        test2: "",
        test3: "",
        userloading: false,
        act: 1,
        loading1: false,
        tableData1: [],
        header: [],
        Heighttab: null,
        values: [],
        zdb_value1: "",
        zdb_value2: "",
        ydb_value1: "",
        ydb_value2: "",
      };
    },
    components: {
      centerLeft1,
      centerLeft2,
      bottomLeft4,
      centerLeftage,
      centerLeft3,
      centerLeft4,
      centerRight1,
      centerRight2,
      bottomRight3,
      bottomRight4,
      center,
      bottomLeft,
      bottomLeft2,
      bottomRight,
      bottomRight2,
      threecenter,
      viplevel,
    },
    created() {},
    mounted() {
      this.getHeight();
      if (this.$openws.ws && this.$openws.ws.getState()) {
        // this.$openws.ws.close()
        setTimeout(async () => {
          // await this.$openws.openws()
          await this.connect(1);
        }, 500);
      } else {
        setTimeout(async () => {
          // await this.$openws.openws()
          await this.connect(1);
        }, 500);
      }
      this.$nextTick(() => {
        // this.allsearch();
        this.getDataList(1);
      });
    },
    beforeDestroy() {
      clearInterval(this.timing);
    },
    watch: {
      "$parent.$parent.$parent.$parent.isCollapse"(n, o) {
        this.allsearch();
      },
    },
    methods: {
      // 昨天
      last_search() {
        let that = this;
        let nowDate = new Date();
        nowDate.setTime(nowDate.getTime() - 24 * 60 * 60 * 1000);
        let year = nowDate.getFullYear();
        let month = nowDate.getMonth() + 1;
        let day = nowDate.getDate();
        month = month > 9 ? month : '0' + month
        day = day > 9 ? day : '0' + day
        let endTime = `${year}-${month}-${day}`;
        that.fm_dated = [endTime, endTime];


        that.searchday();
      },
      // 3天
      three_search() {
        let that = this;
        this.to_three()


        that.searchday();
      },
      to_three() {
        let nowDate = new Date(new Date().getTime() - 1 * 24 * 3600 * 1000)
        let year = nowDate.getFullYear();
        let month = nowDate.getMonth() + 1;
        let day = nowDate.getDate();
        month = month > 9 ? month : '0' + month
        day = day > 9 ? day : '0' + day
        let endTime = `${year}-${month}-${day}`;
        let befDate = new Date(nowDate.getTime() - 2 * 24 * 3600 * 1000);
        let byear = befDate.getFullYear();
        let bmonth = befDate.getMonth() + 1;
        let bday = befDate.getDate();
        bmonth = bmonth > 9 ? bmonth : '0' + bmonth
        bday = bday > 9 ? bday : '0' + bday
        let startTime = `${byear}-${bmonth}-${bday}`;
        let that = this;
        that.fm_dated = [
          byear + "-" + bmonth + "-" + bday,
          year + "-" + month + "-" + day
        ];
      },
      // 5天
      five_search() {
        let nowDate = new Date(new Date().getTime() - 1 * 24 * 3600 * 1000)
        let year = nowDate.getFullYear();
        let month = nowDate.getMonth() + 1;
        let day = nowDate.getDate();
        month = month > 9 ? month : '0' + month
        day = day > 9 ? day : '0' + day
        let endTime = `${year}-${month}-${day}`;
        let befDate = new Date(nowDate.getTime() - 4 * 24 * 3600 * 1000);
        let byear = befDate.getFullYear();
        let bmonth = befDate.getMonth() + 1;
        let bday = befDate.getDate();
        bmonth = bmonth > 9 ? bmonth : '0' + bmonth
        bday = bday > 9 ? bday : '0' + bday
        let startTime = `${byear}-${bmonth}-${bday}`;
        let that = this;
        that.fm_dated = [
          byear + "-" + bmonth + "-" + bday,
          year + "-" + month + "-" + day
        ];


        that.searchday();
      },
      // 7天
      seven_search() {
        let nowDate = new Date(new Date().getTime() - 1 * 24 * 3600 * 1000)
        let year = nowDate.getFullYear();
        let month = nowDate.getMonth() + 1;
        let day = nowDate.getDate();
        month = month > 9 ? month : '0' + month
        day = day > 9 ? day : '0' + day
        let endTime = `${year}-${month}-${day}`;
        let befDate = new Date(nowDate.getTime() - 6 * 24 * 3600 * 1000);
        let byear = befDate.getFullYear();
        let bmonth = befDate.getMonth() + 1;
        let bday = befDate.getDate();
        bmonth = bmonth > 9 ? bmonth : '0' + bmonth
        bday = bday > 9 ? bday : '0' + bday
        let startTime = `${byear}-${bmonth}-${bday}`;
        let that = this;
        that.fm_dated = [
          byear + "-" + bmonth + "-" + bday,
          year + "-" + month + "-" + day
        ];


        that.searchday();
      },
      fifth_search() {
        let nowDate = new Date(new Date().getTime() - 1 * 24 * 3600 * 1000)
        let year = nowDate.getFullYear();
        let month = nowDate.getMonth() + 1;
        let day = nowDate.getDate();
        month = month > 9 ? month : '0' + month
        day = day > 9 ? day : '0' + day
        let endTime = `${year}-${month}-${day}`;
        let befDate = new Date(nowDate.getTime() - 14 * 24 * 3600 * 1000);
        let byear = befDate.getFullYear();
        let bmonth = befDate.getMonth() + 1;
        let bday = befDate.getDate();
        bmonth = bmonth > 9 ? bmonth : '0' + bmonth
        bday = bday > 9 ? bday : '0' + bday
        let startTime = `${byear}-${bmonth}-${bday}`;
        let that = this;
        that.fm_dated = [
          byear + "-" + bmonth + "-" + bday,
          year + "-" + month + "-" + day
        ];


        that.searchday();
      },
      // 本月
      month_search() {
        let that = this
        var date = new Date();
        var month = parseInt(date.getMonth() + 1);
        var day = date.getDate();
        if (month < 10) month = "0" + month;
        let yuechu = date.getFullYear() + "-" + month + "-" + '01';
        if (day == 1) {
          that.fm_dated = [yuechu, yuechu]
        } else {
          day = day - 1;
          if (day < 10) day = "0" + day;
          let yuedi = date.getFullYear() + "-" + month + "-" + day;
          that.fm_dated = [yuechu, yuedi]
        }


        that.searchday();
      },
      // 上月
      lastmonth_search() {
        let nowDate = new Date();
        let year = nowDate.getFullYear();
        let month = nowDate.getMonth();
        nowDate.setDate(0);
        let day = nowDate.getDate();
        month = month > 9 ? month : '0' + month
        day = day > 9 ? day : '0' + day
        let endTime = `${year}-${month}-${day}`;
        this.nowTime = endTime; // 当前的时间点
        let befDate = new Date(nowDate.getTime());
        let byear = befDate.getFullYear();
        let bmonth = befDate.getMonth() + 1;
        let bday = befDate.getDate();
        bmonth = bmonth > 9 ? bmonth : '0' + bmonth
        bday = bday > 9 ? bday : '0' + bday
        let startTime = `${byear}-${bmonth}-${bday}`;
        this.weekBeforeTime = startTime; // 向前推迟一周的时间点
        let that = this;
        that.fm_dated = [
          byear + "-" + bmonth + "-" + "01",
          byear + "-" + bmonth + "-" + day
        ];


        that.searchday();
      },
      //日报表
      searchday() {
        let that = this;
        // that.loading = true;
        if (that.fm_dated.length == 0) return this.$message('请先选择时间')
        that.zdb_value1 = ''
        that.zdb_value2 = ''
        that.ydb_value1 = ''
        that.ydb_value2 = ''
        that.header = [];
        that.tableData1 = [];
        this.loading1 = true
        axios
          .post(
            "/admin/pc/report/getAllUserReport", {
              start_time: that.fm_dated[0],
              end_time: that.fm_dated[1],
              time_type: "1",
            }, {
              token: true,
            }
          )
          .then((response) => {
            that.loading1 = false;
            that.header = response.data.data.header;
            that.tableData1 = response.data.data.list;
            // that.$nextTick(() => {
            //   that.$refs.table.doLayout();
            // });
          })
          .catch((error) => {});
      },
      //日报表
      search_day() {
        let that = this;
        // that.loading = true;
        if (that.values.length == 0) return this.$message('请先选择时间')
        that.zdb_value1 = ''
        that.zdb_value2 = ''
        that.ydb_value1 = ''
        that.ydb_value2 = ''
        that.header = [];
        that.tableData1 = [];
        this.loading1 = true
        axios
          .post(
            "/admin/pc/report/getAllUserReport", {
              start_time: that.values[0],
              end_time: that.values[1],
              time_type: "1",
            }, {
              token: true,
            }
          )
          .then((response) => {
            that.loading1 = false;
            that.header = response.data.data.header;
            that.tableData1 = response.data.data.list;
            // that.$nextTick(() => {
            //   that.$refs.table.doLayout();
            // });
          })
          .catch((error) => {});
      },
      //周报表
      search_week() {
        let that = this;
        that.values = []
        that.ydb_value1 = ''
        that.ydb_value2 = ''
        var week1 = this.$refs.week1.displayValue;
        var week2 = this.$refs.week2.displayValue;
        that.header = [];
        that.tableData1 = [];
        if (week1 && week2) {
          var w1 = week1.split("第 ")[1];
          w1 = w1.split(" 周")[0];
          var w2 = week2.split("第 ")[1];
          w2 = w2.split(" 周")[0];
          this.loading1 = true

          axios
            .post(
              "/admin/pc/report/getAllUserReport", {
                start_time: that.zdb_value1,
                end_time: that.zdb_value2,
                time_type: "3",
              }, {
                token: true,
              }
            )
            .then((response) => {
              this.loading1 = false
              that.header = response.data.data.header;
              that.tableData1 = response.data.data.list;
              that.$nextTick(() => {
                that.$refs.table.doLayout();
              });
            })
            .catch((error) => {});
        } else {
          this.$message({
            showClose: true,
            message: "请先选择第几周",
            type: "warning",
          });
        }
      },
      //月报表
      search_month() {
        let that = this;
        that.values = []
        that.zdb_value1 = ''
        that.zdb_value2 = ''
        that.header = [];
        that.tableData1 = [];
        if (this.ydb_value1 && this.ydb_value2) {
          this.loading1 = true
          axios
            .post(
              "/admin/pc/report/getAllUserReport", {
                start_time: that.ydb_value1,
                end_time: that.ydb_value2,

                time_type: "2",
              }, {
                token: true,
              }
            )
            .then((response) => {
              this.loading1 = false
              that.header = response.data.data.header;
              that.tableData1 = response.data.data.list;
              that.$nextTick(() => {
                that.$refs.table.doLayout();
              });
            })
            .catch((error) => {});
        } else {
          that.loading = false;
          this.$message({
            showClose: true,
            message: "请先选择月份",
            type: "warning",
          });
        }
      },
      getHeight() {
        let that = this;
        that.bgheight = window.innerHeight - 54 - 60;
        window.onresize = () => {
          that.bgheight = window.innerHeight - 104;
        };
      },
      async allsearch() {
        this.loading = true;
        this.timeFn();
        this.$nextTick(async () => {
          await this.cancelLoading();
          // await this.begin('all')
        });
      },
      timeFn() {
        this.timing = setInterval(() => {
          this.dateDay = formatTime(new Date(), "HH: mm: ss");
          this.dateYear = formatTime(new Date(), "yyyy-MM-dd");
          this.dateWeek = this.weekday[new Date().getDay()];
        }, 1000);
      },
      async cancelLoading() {
        let timer = await setTimeout(async () => {
          this.loading = false;
          this.getyszb();
          this.getnlfb();
          await this.getzxl();
          await this.getmoneydata();
          this.getdau2(1);
          // await this.getzhuce()
          this.getguanzhe();
          await this.getdata();
        }, 500);
      },

      // 浏览记录
      async begin(t) {
        let that = this;
        that.currentPage = 1;
        that.pagesize = 10;
        if (t != "all") {
          this.getmoneydata();
          this.getdau(1);
          this.getguanzhe();
          // this.getzhuce()
          // this.getdau(2)
        }
        // await that.search()
      },
      async search() {
        this.loadings = true;
        await axios
          .post(
            "/admin/BrowsingHistory/index", {
              page: this.currentPage,
              page_count: this.pagesize,
              source: 1,
              start_time: this.timess ? this.timess[0] : "",
              end_time: this.timess ? this.timess[1] : "",
              // ip_province: this.formData.sfval,
              // behavior_id: this.formData.xwval,
              // regular: this.formData.mkval,
              // user_id: this.formData.user_value
            }, {
              token: true,
            }
          )
          .then((response) => {
            this.loadings = false;
            this.tableData = response.data.data.list;
            this.count = response.data.data.count;
            // this.pageData = response.data.data.pageData
            // this.provinceData = response.data.data.provinceData
            // this.weekData = response.data.data.weekData
          })
          .catch((error) => {});
      },
      async getyszb() {
        await axios
          .post(
            "/admin/pc/report/docProportion", {}, {
              token: true,
            }
          )
          .then((res) => {
            let arr1 = [];
            let arr2 = [];
            if (res.data.code == 200) {
              res.data.data.prov.forEach((e) => {
                arr1.push({
                  value: e.count,
                  name: e.province,
                });
              });
              res.data.data.competent.forEach((e) => {
                arr2.push({
                  value: e.count,
                  name: e.competent_id_text,
                });
              });
              let total = {
                value: res.data.data.total,
                name: "医生总量",
              };
              this.$nextTick(() => {
                this.$refs.centerLeft1.$children[2].cdata = arr1;
                this.$refs.centerLeft1.titleItem = [total, ...arr1];
                this.$refs.centerLeft2.$children[2].cdata = arr2;
                this.$refs.centerLeft2.titleItem = [total, ...arr2];
              });
            }
          })
          .catch((error) => {});
      },
      getnlfb() {
        axios
          .post(
            "/admin/pc/report/docAgeDistribution", {}, {
              token: true,
            }
          )
          .then((res) => {
            let arr1 = [];
            let totals = 0;
            if (res.data.code == 200) {
              res.data.data.result.forEach((e) => {
                totals += e.count;
                arr1.push({
                  value: e.count,
                  name: e.name,
                });
              });
              let doctotal = {
                value: totals,
                name: "医生总量",
              };
              this.$nextTick(() => {
                this.$refs.centerLeftage.$children[2].cdata = arr1;
                this.$refs.centerLeftage.titleItem = [doctotal, ...arr1];
              });
            }
          })
          .catch((error) => {});
      },
      async getzxl() {
        await axios
          .post(
            "/admin/pc/report/consultation", {}, {
              token: true,
            }
          )
          .then((res) => {
            let data = res.data.data.chatIncome[0];
            let arr = [data.day_count, data.week_count, data.month_count];
            this.$refs.centerLeft3.$children[2].cdata = arr;
          })
          .catch((error) => {});
      },
      async getdau(t) {
        await axios
          .post(
            "/admin/pc/report/activeSituation", {
              start_time: this.timess ? this.timess[0] : "",
              end_time: this.timess ? this.timess[1] : "",
              time_type: t,
            }, {
              token: true,
            }
          )
          .then((res) => {
            if (res.data.code == 200) {
              let data = res.data.data;
              let objs = {};
              let arr = [];
              let counts = [];
              data.list.forEach((e) => {
                arr.push({
                  name: e.name,
                  type: e.type,
                  data: e.data,
                  count: e.count,
                  label: e.label,
                });
                counts.push({
                  c: e.count,
                });
              });
              objs = {
                times: data.dateTitle,
                list: arr,
                counts: counts,
              };
              // if (t != 2) {
              // this.$refs.bottomLeft1.$children[1].cdata = objs;

              // let arr2 = [data.list[3].count];
              let arr2 = [data.list[2].count];
              this.$refs.bottomRight.$children[2].cdata = arr2;
              this.$refs.bottomRight.$children[2].tabnames = ["总量"];
              this.userloading = false;
              // } else {
              //   this.$refs.bottomLeft2.$children[1].cdata = objs
              // }
            } else {
              this.$message.error((t != 2 ? "DAU" : "MAU") + res.data.msg);
            }
          })
          .catch((error) => {});
      },
      async getdau2(t) {
        await axios
          .post(
            "/admin/pc/report/activeSituation", {
              start_time: this.timess ? this.timess[0] : "",
              end_time: this.timess ? this.timess[1] : "",
              time_type: t,
            }, {
              token: true,
            }
          )
          .then((res) => {
            if (res.data.code == 200) {
              let data = res.data.data;
              let objs = {};
              let arr = [];
              let counts = [];
              data.list.forEach((e) => {
                arr.push({
                  name: e.name,
                  type: e.type,
                  data: e.data,
                  count: e.count,
                  label: e.label,
                });
                counts.push({
                  c: e.count,
                });
              });
              objs = {
                times: data.dateTitle,
                list: arr,
                counts: counts,
              };
              // if (t != 2) {
              this.$refs.bottomLeft1.$children[1].cdata = objs;

              // let arr2 = [data.list[3].count];
              // let arr2 = [data.list[2].count];
              // this.$refs.bottomRight.$children[2].cdata = arr2;
              // this.$refs.bottomRight.$children[2].tabnames = ["总量"];
              this.userloading = false;
              // } else {
              //   this.$refs.bottomLeft2.$children[1].cdata = objs
              // }
            } else {
              this.$message.error((t != 2 ? "DAU" : "MAU") + res.data.msg);
            }
          })
          .catch((error) => {});
      },
      async getzhuce() {
        await axios
          .post(
            "/admin/pc/report/registerReport", {
              start_time: this.timess ? this.timess[0] : "",
              end_time: this.timess ? this.timess[1] : "",
            }, {
              token: true,
            }
          )
          .then((res) => {
            if (res.data.code == 200) {
              let data = res.data.data.register[0];
              let arr = [data.day_count, data.week_count, data.month_count];
              // this.$refs.bottomRight.$children[2].cdata = arr
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((error) => {});
      },
      //四个按钮切换表格
      getDataList(n) {
        this.boxshow = n;
        this.act = n;
        if (n == 1) {
          this.userloading = true;
          this.ishow = 1;
          this.test = "用户";
          // this.getdau(1);
          this.getguanzhe();
          this.loading = false;
        } else if (n == 2) {
          this.test = "关注";
          this.ishow = 1;
          this.getguanzhuData();
        } else if (n == 3) {
          this.ishow = 2;
          this.getzhuanhuaData();
        } else if (n == 4) {
          //其他按钮
          this.$nextTick(() => {
            this.allsearch();
          });
        } else if (n == 5) {
          this.ishow = 1;
          this.getUserData();
        }
      },
      //关注按钮
      getguanzhuData() {
        axios
          .post(
            "/admin/pc/report/wechatUser", {
              start_time: this.timess ? this.timess[0] : "",
              end_time: this.timess ? this.timess[1] : "",
            }, {
              token: true,
            }
          )
          .then((res) => {
            if (res.data.code == 200) {
              let data = res.data.data.follow[0];
              let arr1 = [
                data.user_wechat_day_count,
                data.user_doctor_day_count,
                data.user_org_day_count,
                data.day_count,
              ];
              let arr2 = [
                data.user_wechat_week_count,
                data.user_doctor_week_count,
                data.user_org_week_count,
                data.week_count,
              ];
              let arr3 = [
                data.user_wechat_month_count,
                data.user_doctor_month_count,
                data.user_org_month_count,
                data.month_count,
              ];
              this.$refs.bottomRight213.$children[2].cdata = arr1;
              this.$refs.bottomRight213.$children[2].tabnames = [
                "用户",
                "医生",
                "机构",
                "日总",
              ];
              this.$refs.bottomRight214.$children[2].cdata = arr2;
              this.$refs.bottomRight214.$children[2].tabnames = [
                "用户",
                "医生",
                "机构",
                "周总",
              ];
              this.$refs.bottomRight215.$children[2].cdata = arr3;
              this.$refs.bottomRight215.$children[2].tabnames = [
                "用户",
                "医生",
                "机构",
                "月总",
              ];

              this.$refs.bottomRight216.$children[2].tabnames = [
                "用户总",
                "医生总",
                "机构总",
                "总",
              ];
              this.$refs.bottomRight216.$children[2].ecolor = "#4f98df";
              this.$refs.bottomRight216.$children[2].cdata = [
                data.user_wechat_total_count,
                data.user_doctor_total_count,
                data.user_org_total_count,
                data.user_doctor_total_count +
                data.user_wechat_total_count +
                data.user_org_total_count,
              ];
              // this.$refs.bottomRight217.$children[2].tabnames = ["总"];
              // this.$refs.bottomRight217.$children[2].ecolor = "#4f98df";
              // this.$refs.bottomRight217.$children[2].cdata = [
              //   data.user_wechat_total_count,
              // ];
              // this.$refs.bottomRight218.$children[2].tabnames = ["总"];
              // this.$refs.bottomRight218.$children[2].ecolor = "#9ecf8e";
              // this.$refs.bottomRight218.$children[2].cdata = [
              //   data.user_doctor_total_count,
              // ];
              // this.$refs.bottomRight219.$children[2].tabnames = ["总"];
              // this.$refs.bottomRight219.$children[2].ecolor = "#feb041";
              // this.$refs.bottomRight219.$children[2].cdata = [
              //   data.user_org_total_count,
              // ];

              // this.$refs.bottomRight24.$children[2].cdata = [
              //   data.user_wechat_day_count,
              // ];
              // this.$refs.bottomRight24.$children[2].tabnames = ["日"];
              // this.$refs.bottomRight24.$children[2].ecolor = "#4f98df";
              // this.$refs.bottomRight25.$children[2].cdata = [
              //   data.user_wechat_week_count,
              // ];
              // this.$refs.bottomRight25.$children[2].tabnames = ["周"];
              // this.$refs.bottomRight25.$children[2].ecolor = "#4f98df";
              // this.$refs.bottomRight26.$children[2].cdata = [
              //   data.user_wechat_month_count,
              // ];
              // this.$refs.bottomRight26.$children[2].tabnames = ["月"];
              // this.$refs.bottomRight26.$children[2].ecolor = "#4f98df";

              // this.$refs.bottomRight27.$children[2].cdata = [
              //   data.user_doctor_day_count,
              // ];
              // this.$refs.bottomRight27.$children[2].tabnames = ["日"];
              // this.$refs.bottomRight27.$children[2].ecolor = "#9ecf8e";
              // this.$refs.bottomRight28.$children[2].cdata = [
              //   data.user_doctor_week_count,
              // ];
              // this.$refs.bottomRight28.$children[2].tabnames = ["周"];
              // this.$refs.bottomRight28.$children[2].ecolor = "#9ecf8e";
              // this.$refs.bottomRight29.$children[2].cdata = [
              //   data.user_doctor_month_count,
              // ];
              // this.$refs.bottomRight29.$children[2].tabnames = ["月"];
              // this.$refs.bottomRight29.$children[2].ecolor = "#9ecf8e";
              // this.$refs.bottomRight210.$children[2].cdata = [
              //   data.user_org_day_count,
              // ];
              // this.$refs.bottomRight210.$children[2].tabnames = ["日"];
              // this.$refs.bottomRight210.$children[2].ecolor = "#feb041";
              // this.$refs.bottomRight211.$children[2].cdata = [
              //   data.user_doctor_week_count,
              // ];
              // this.$refs.bottomRight211.$children[2].tabnames = ["周"];
              // this.$refs.bottomRight211.$children[2].ecolor = "#feb041";
              // this.$refs.bottomRight212.$children[2].cdata = [
              //   data.user_org_month_count,
              // ];
              // this.$refs.bottomRight212.$children[2].tabnames = ["月"];
              // this.$refs.bottomRight212.$children[2].ecolor = "#feb041";
              // this.$refs.bottomRight21.$children[2].cdata = [data.day_count];
              // this.$refs.bottomRight21.$children[2].tabnames = ["日总量"];
              // this.$refs.bottomRight22.$children[2].cdata = [data.week_count];
              // this.$refs.bottomRight22.$children[2].tabnames = ["周总量"];
              // this.$refs.bottomRight23.$children[2].cdata = [data.month_count];
              // this.$refs.bottomRight23.$children[2].tabnames = ["月总量"];
              this.loading = false;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((error) => {});
      },
      //转化量
      getzhuanhuaData() {
        axios
          .post(
            "/admin/pc/report/orderItemData", {
              start_time: this.timess ? this.timess[0] : "",
              end_time: this.timess ? this.timess[1] : "",
            }, {
              token: true,
            }
          )
          .then((res) => {
            if (res.data.code == 200) {
              //新增用户量
              let data = res.data.data.follow_doctorInquiry[0];
              let arr = [data.day_count, data.week_count, data.month_count];
              this.$refs.bottomLeft4.$children[2].cdata = arr;
              this.$refs.bottomLeft4.$children[2].tabnames = ["日", "周", "月"];
              let data2 = res.data.data.follow_order[0];
              let arr1 = [data2.day_count, data2.week_count, data2.month_count];
              this.$refs.bottomLeft4.$children[2].edata = arr1;

              //总量
              let arr3 = [res.data.data.total_doctorInquiry - 0];
              let arr4 = [res.data.data.total_order - 0];
              this.$refs.bottomRight3.$children[2].cdata = arr3;
              this.$refs.bottomRight3.$children[2].tabnames = ["总量"];
              this.$refs.bottomRight3.$children[2].edata = arr4;
              this.loading = false;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((error) => {});
      },
      //日活
      getUserData() {
        axios
          .post(
            "/admin/pc/report/activeSituationUser", {
              start_time: this.timess ? this.timess[0] : "",
              end_time: this.timess ? this.timess[1] : "",
            }, {
              token: true,
            }
          )
          .then((res) => {
            if (res.data.code == 200) {
              let data = res.data.data.follow_user[0];
              let data2 = res.data.data.follow_doctor[0];
              let data3 = res.data.data.follow_org[0];
              let data4 = res.data.data.follow_total[0];
              let arr1 = [
                data.day_count,
                data2.day_count,
                data3.day_count,
                data4.day_count,
              ];
              let arr4 = [
                data.week_count,
                data2.week_count,
                data3.week_count,
                data4.week_count,
              ];
              let arr3 = [
                data.month_count,
                data2.month_count,
                data3.month_count,
                data4.month_count,
              ];
              //第一行三个柱子的图
              this.$refs.bottomRight513.$children[2].cdata = arr1;
              this.$refs.bottomRight513.$children[2].tabnames = [
                "用户",
                "医生",
                "机构",
                "日总",
              ];
              this.$refs.bottomRight514.$children[2].cdata = arr4;
              this.$refs.bottomRight514.$children[2].tabnames = [
                "用户",
                "医生",
                "机构",
                "周总",
              ];
              this.$refs.bottomRight515.$children[2].cdata = arr3;
              this.$refs.bottomRight515.$children[2].tabnames = [
                "用户",
                "医生",
                "机构",
                "月总",
              ];

              //总量
              this.$refs.bottomRight516.$children[2].tabnames = [
                "用户总",
                "医生总",
                "机构总",
                "总",
              ];
              this.$refs.bottomRight516.$children[2].ecolor = "#4f98df";
              this.$refs.bottomRight516.$children[2].cdata = [
                data.total_count,
                data2.total_count,
                data3.total_count,
                data.total_count + data2.total_count + data3.total_count,
              ];
              // this.$refs.bottomRight517.$children[2].tabnames = ["总"];
              // this.$refs.bottomRight517.$children[2].ecolor = "#4f98df";
              // this.$refs.bottomRight517.$children[2].cdata = [
              //   data.total_count,
              // ];
              // this.$refs.bottomRight518.$children[2].tabnames = ["总"];
              // this.$refs.bottomRight518.$children[2].ecolor = "#9ecf8e";
              // this.$refs.bottomRight518.$children[2].cdata = [
              //   data2.total_count,
              // ];
              // this.$refs.bottomRight519.$children[2].tabnames = ["总"];
              // this.$refs.bottomRight519.$children[2].ecolor = "#feb041";
              // this.$refs.bottomRight519.$children[2].cdata = [
              //   data3.total_count,
              // ];

              // //用户日周月活
              // this.$refs.bottomRight54.$children[2].cdata = [data.day_count];
              // this.$refs.bottomRight54.$children[2].tabnames = ["日"];
              // this.$refs.bottomRight54.$children[2].ecolor = "#4f98df";

              // this.$refs.bottomRight55.$children[2].cdata = [data.week_count];
              // this.$refs.bottomRight55.$children[2].tabnames = ["周"];
              // this.$refs.bottomRight55.$children[2].ecolor = "#4f98df";

              // this.$refs.bottomRight56.$children[2].cdata = [data.month_count];
              // this.$refs.bottomRight56.$children[2].tabnames = ["月"];
              // this.$refs.bottomRight56.$children[2].ecolor = "#4f98df";
              // //医生日周月活
              // this.$refs.bottomRight57.$children[2].cdata = [data2.day_count];
              // this.$refs.bottomRight57.$children[2].tabnames = ["日"];
              // this.$refs.bottomRight57.$children[2].ecolor = "#9ecf8e";

              // this.$refs.bottomRight58.$children[2].cdata = [data2.week_count];
              // this.$refs.bottomRight58.$children[2].tabnames = ["周"];
              // this.$refs.bottomRight58.$children[2].ecolor = "#9ecf8e";

              // this.$refs.bottomRight59.$children[2].cdata = [data2.month_count];
              // this.$refs.bottomRight59.$children[2].tabnames = ["月"];
              // this.$refs.bottomRight59.$children[2].ecolor = "#9ecf8e";
              // //机构日周月活
              // this.$refs.bottomRight510.$children[2].cdata = [data3.day_count];
              // this.$refs.bottomRight510.$children[2].tabnames = ["日"];
              // this.$refs.bottomRight510.$children[2].ecolor = "#feb041";

              // this.$refs.bottomRight511.$children[2].cdata = [data3.week_count];
              // this.$refs.bottomRight511.$children[2].tabnames = ["周"];
              // this.$refs.bottomRight511.$children[2].ecolor = "#feb041";

              // this.$refs.bottomRight512.$children[2].cdata = [data3.month_count];
              // this.$refs.bottomRight512.$children[2].tabnames = ["月"];
              // this.$refs.bottomRight512.$children[2].ecolor = "#feb041";

              // let arr2 = [res.data.data.total_user];
              // this.$refs.bottomRight51.$children[2].cdata = arr2;
              // this.$refs.bottomRight51.$children[2].tabnames = ["总量"];
              // this.$refs.bottomRight52.$children[2].cdata = arr2;
              // this.$refs.bottomRight52.$children[2].tabnames = ["总量"];
              // this.$refs.bottomRight53.$children[2].cdata = arr2;
              // this.$refs.bottomRight53.$children[2].tabnames = ["总量"];
              this.loading = false;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((error) => {});
      },
      //进入页面时用户数据
      getguanzhe() {
        axios
          .post(
            "/admin/pc/report/userFollow", {
              start_time: this.timess ? this.timess[0] : "",
              end_time: this.timess ? this.timess[1] : "",
            }, {
              token: true,
            }
          )
          .then((res) => {
            if (res.data.code == 200) {
              let data = res.data.data.follow[0];
              let arr = [
                data.user_wechat_day_count,
                data.user_doctor_day_count,
                data.user_org_day_count,
                data.day_count,
              ];
              let arr2 = [
                data.user_wechat_week_count,
                data.user_doctor_week_count,
                data.user_org_week_count,
                data.week_count,
              ];
              let arr3 = [
                data.user_wechat_month_count,
                data.user_doctor_month_count,
                data.user_org_month_count,
                data.month_count,
              ];
              let arr4 = [
                data.user_wechat_count,
                data.user_doctor_count,
                data.user_org_count,
                data.count,
              ];
              this.$refs.bottomRight2_1.$children[2].cdata = arr;
              this.$refs.bottomRight2_1.$children[2].tabnames = [
                "用户",
                "医生",
                "机构",
                "日总",
              ];
              this.$refs.bottomRight2_2.$children[2].cdata = arr2;
              this.$refs.bottomRight2_2.$children[2].tabnames = [
                "用户",
                "医生",
                "机构",
                "周总",
              ];
              this.$refs.bottomRight2_3.$children[2].cdata = arr3;
              this.$refs.bottomRight2_3.$children[2].tabnames = [
                "用户",
                "医生",
                "机构",
                "月总",
              ];

              this.$refs.bottomRight.$children[2].cdata = arr4;
              this.$refs.bottomRight.$children[2].tabnames = [
                "用户",
                "医生",
                "机构",
                "总量",
              ];
              this.userloading = false;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((error) => {});
      },
      async getmoneydata() {
        await axios
          .post(
            "/admin/pc/report/financial", {
              start_time: this.timess ? this.timess[0] : "",
              end_time: this.timess ? this.timess[1] : "",
            }, {
              token: true,
            }
          )
          .then((res) => {
            let data = res.data.data;
            let arr = [
              data.chatIncome,
              {
                value: data.expenditure,
                itemStyle: {
                  color: "#a90000",
                },
              },
              {
                value: data.mallIncome,
                itemStyle: {
                  color: "#0078ff",
                },
              },
            ];
            this.$nextTick(() => {
              if (this.$refs.centerLeft4) {
                this.$refs.centerLeft4.$children[2].cdata = arr;
              }
            });
          })
          .catch((error) => {});
      },
      handleSizeChange(val) {
        let that = this;
        that.pagesize = val;
        that.search();
      },
      handleCurrentChange(val) {
        let that = this;
        that.currentPage = val;
        that.search();
      },
      // 导出数据
      exportExcel() {
        if (!this.exportForm.time) {
          return this.$message({
            type: "error",
            message: "时间不能为空！",
          });
        }
        this.dcing = true;
        let url = `/admin/pc/Excel/logReport2Excel`;
        let params = "";
        let val = this.exportForm.time;
        if (val) {
          params += `&starttime=${val}`;
        }
        this.axios
          .post(
            url + params, {}, {
              token: true,
              responseType: "blob",
            }
          )
          .then((res) => {
            this.exportModal = false;
            if (res.status == 200) {
              let url = window.URL.createObjectURL(new Blob([res.data]));
              let link = document.createElement("a");
              link.style.display = "none";
              link.href = url;
              let filename = new Date().getTime() + ".xlsx";
              link.setAttribute("download", filename);
              document.body.appendChild(link);
              link.click();
            }
            this.dcing = false;
          })
          .catch((err) => {
            this.dcing = false;
          });
      },
      async getdata(t) {
        await axios
          .post(
            "/admin/pc/homepage/homePageData", {}, {
              token: true,
            }
          )
          .then((res) => {
            if (res.data.code == 200) {
              if (t == 1) {
                // this.$message.success('刷新成功！')
              }
            }
          });

      },

      async connect() {
        let that = this;
        this.$openws.ws.homePage = function (text, type) {
          if (text.msg_source == "homePage") {
            if (text.modular == "inquiry") {
              that.inquirys = text.data;
            }
            if (text.modular == "mall") {
              that.malls = text.data;
            }
            if (text.modular == "userRegister") {
              that.userRegisters = text.data;
            }
            if (text.modular == "docRegister") {
              that.docRegisters = text.data;
            }
            if (text.modular == "phoneUser") {
              that.phoneUsers = text.data;
            }
          }
        };
        // 接诊提醒
        this.$openws.ws.inquiryRemind = function (text, type) {
          this.$notify.info({
            title: '新咨询订单',
            message: text.data,
            position: 'bottom-right',
          });
        };
      },
    },
    destroyed() {
      this.$openws.connect();
    },
  };
</script>

<style lang="scss" scoped>
  .search_b {
    position: absolute;
    top: 12px;
    right: 50px;

    .search_btn1 {
      margin-right: 10px;
    }

    .search_btn {
      margin-left: 10px;
    }
  }

  .bg {
    width: 100%;
    height: 100%;
    padding: 16px 16px 0 16px;
    background-image: url("../../../assets/pageBg.png");
    background-size: cover;
    background-position: center center;
    overflow: auto;
  }

  .tabssty {
    padding: 20px 15px;

    /deep/ .tabhstyle th {
      background-color: rgba(19, 25, 47, 0.1) !important;
      color: #fff;
    }

    /deep/ .el-table tr {
      background-color: rgba(19, 25, 47, 0.1);
    }

    /deep/.el-table thead {
      background-color: rgba(19, 25, 47, 0.1) !important;
    }

    /deep/ .el-table {
      background-color: rgba(19, 25, 47, 0.1) !important;
      color: #fff;
    }

    /deep/ .el-table--enable-row-hover .el-table__body tr:hover>td {
      background-color: rgba(#fff, 0.2) !important;
    }

    /deep/ .el-pagination__total {
      color: #fff;
    }

    /deep/.el-pagination__jump {
      color: #fff;
    }

    .el-table {
      /deep/ .el-table__body-wrapper {
        &::-webkit-scrollbar {
          width: 7px !important;
          height: 7px;
        }

        /*定义滚动条轨道 内阴影+圆角*/
        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background-color: transparent;
        }

        /*定义滑块 内阴影+圆角*/
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: #fff;
        }
      }

    }

  }

  .dc_btn_b {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 5px;
  }

  .add_tits {
    .el-form-item {
      margin-bottom: 0 !important
    }
  }

  @import "../../../assets/scss/index.scss";
</style>